import { baseUrl, toQueryParameter } from '../../utils';
const computeLabel = ({
  productType,
  process
}) => `${productType}_${process}`;
const getProductType = productType => {
  if (productType === 'domain') {
    return 'domain/details';
  }
  return productType;
};
export const fetchPrices = resource => args => dispatch => {
  let queryParams = {
    process: args.process
  };
  if (args.currency) {
    queryParams = {
      ...queryParams,
      currency: args.currency
    };
  }
  if (args.grid) {
    queryParams = {
      ...queryParams,
      grid: args.grid
    };
  }
  if (args.sharingId) {
    queryParams = {
      ...queryParams,
      sharingId: args.sharingId
    };
  }
  let url = [baseUrl, getProductType(args.productType)].join('/');
  url = `${url}?${toQueryParameter(queryParams)}`;
  return dispatch(resource.fetchOne(url, {
    label: computeLabel(args),
    on200: response => response,
    not200: response => Promise.reject(response)
  }));
};
export const selectRaw = state => state.gandiReduxResourcePrice;
export const selectPrices = (state, props) => {
  const raw = selectRaw(state);
  const label = computeLabel(props.params);
  return raw[props.product]?.[label];
};